import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "@features/comments/editor-comment.css";
import useComments from "@hooks/useComments";
import EditorCommentCreateBox from "@features/comments/editor-comment-create-box";
import { Grid } from "@mzc-pdc/ui";
import ReplyContainer from "@features/comments/domain/reply-container";
import ThreadContainer from "@features/comments/domain/thread-container";
import queryParamsParse from "../../components/params/queryParamsParse";
import { resetState } from "@modules/comments";
import useCommentSelector from "@hooks/useCommentSelector";

const CommentService = ({ domain, resourceId, isShowReplyView, isCustomMenu, isCms, projectId, addedUsers }) => {
    const dispatch = useDispatch();
    const {
        onChangeComment,
        onCreateComments,
        onClickToggleExpander,
        onClickCloseReplyContainer,
        onClickBackThreadContainer,
        onChangeAttachments,
        htmlComment,
        attachments,
        userSiteAccess,
    } = useComments({
        domain,
        resourceId,
        isCustomMenu,
        isCms,
        projectId,
    });
    const { isLinkCommentUsed, selectedComment } = useCommentSelector({ domain });

    const { threadId, commentId, isSubThread } = queryParamsParse(location.search);
    const isLinkFromEmail = !!threadId;
    const parsedIsSubThread = isSubThread === "true";

    const isReplyContainerHidden = useMemo(() => {
        if (!isLinkFromEmail || isLinkCommentUsed) {
            return selectedComment;
        } else {
            return parsedIsSubThread;
        }
    }, [isLinkFromEmail, isLinkCommentUsed, selectedComment, parsedIsSubThread]);

    useEffect(() => {
        return () => dispatch(resetState());
    }, []);

    return (
        <>
            <Grid container width={1} flexDirection={"column"} hidden={!isShowReplyView} sx={{ height: "100%" }}>
                <Grid item sx={{ overflowY: `hidden`, width: `100%`, height: `calc(100% - 48px)` }} flex={1}>
                    <ReplyContainer
                        domain={domain}
                        resourceId={resourceId}
                        hidden={!isShowReplyView || isReplyContainerHidden}
                        onClose={onClickCloseReplyContainer}
                        isCustomMenu={isCustomMenu}
                        isCms={isCms}
                        userSiteAccess={userSiteAccess}
                        projectId={projectId}
                        addedUsers={addedUsers}
                    />
                    <ThreadContainer
                        domain={domain}
                        resourceId={resourceId}
                        onClickBack={onClickBackThreadContainer}
                        hidden={!isShowReplyView || !isReplyContainerHidden}
                        projectId={projectId}
                        addedUsers={addedUsers}
                    />
                </Grid>
                <Grid item width={1}>
                    <EditorCommentCreateBox
                        domain={domain}
                        onClickToggleExpander={onClickToggleExpander}
                        onChangeComment={onChangeComment}
                        onChangeAttachments={onChangeAttachments}
                        onCreateComment={onCreateComments}
                        htmlComment={htmlComment}
                        attachments={attachments}
                        isHideExpanderButton={isShowReplyView}
                        userSiteAccess={userSiteAccess}
                        projectId={projectId}
                        addedUsers={addedUsers}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default CommentService;
